
import React, {Component} from "react";

import Badge from "./badge.js";



import "./badges-window.css";


class BadgesWindow extends Component {

    printBadges() {
        let {unlocked_badges} = this.props;


        return unlocked_badges.map((badge) => {
            return <Badge badge_info={badge} />
        });
    }

    render () {
        let {hide_func} = this.props;

        
        return (
            <div className='badges_window_wrap'>
                <div className='badges_modal' onClick={hide_func}></div>
                <div className='badges_window_contanier'>
                    <div className='badges_window'>
                        <div className="badges_window_title">Your Badges</div>
                        <div className="badges_window_close" onClick={hide_func}><i className='fa fa-times'></i></div>
                            <div className='badges_window_content'>{this.printBadges()}</div>
                    </div>
                </div>
                
            </div>
        );
        
    }
}

export default BadgesWindow;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/widgets/badges-window.js